export interface Testimonial {
  initials: string
  name: string
  role: string
  text: string
}

export const stripTestimonials: Testimonial[] = [
  {
    initials: 'MT',
    name: 'Massage Therapist',
    role: 'Verified professional',
    text: '"I used to spend too much time thinking about what I was going to do with each client. Having complete sessions already organized gives me a starting point I can adapt instead of building everything from scratch."',
  },
  {
    initials: 'BP',
    name: 'Bodywork Professional',
    role: 'Verified professional',
    text: '"The anatomy and technique sections are exactly the kind of reference I want nearby. Everything is visual, organized, and connected to real massage application."',
  },
  {
    initials: 'MP',
    name: 'Massage Practitioner',
    role: 'Verified professional',
    text: '"I was falling back on the same routine too often. Having different session goals, durations, body regions, pressure options, and adaptations gives me much more variety."',
  },
]

export const extendedTestimonials: Testimonial[] = [
  {
    initials: 'MT',
    name: 'Massage Therapist',
    role: 'Verified professional · Session structure',
    text: "The biggest difference is that I don't have to invent every session anymore. I can start from a complete structure and spend my time adapting it to the client instead.",
  },
  {
    initials: 'MP',
    name: 'Massage Practitioner',
    role: 'Verified professional · Session variety',
    text: 'The session variety is exactly what I wanted. Different goals, durations, body regions, and client contexts make it much easier to avoid repeating the same routine.',
  },
  {
    initials: 'BP',
    name: 'Bodywork Professional',
    role: 'Verified professional · Applied anatomy',
    text: 'The visual anatomy material makes reviewing the body much faster. It connects the anatomy directly to movement and massage application.',
  },
  {
    initials: 'MT',
    name: 'Massage Therapist',
    role: 'Verified professional · Client adaptations',
    text: 'The adaptation material is especially useful because not every client needs the same session delivered in the same way.',
  },
  {
    initials: 'PT',
    name: 'Professional Massage Therapist',
    role: 'Verified professional · Mini protocols',
    text: 'The mini protocols are the type of resource I would keep close by because they make it easy to add focused work without rebuilding the whole session.',
  },
]
